import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=aea42252&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=aea42252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea42252",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aea42252')) {
      api.createRecord('aea42252', component.options)
    } else {
      api.reload('aea42252', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=aea42252&scoped=true&", function () {
      api.rerender('aea42252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mD2ZaraIB5lp/JS/comp/DocBox.vue"
export default component.exports